const content = {
    nav: {
        logo: 'Ali Chaabane',
        links: [
            // { text: 'Projets', to: 'project' },
            { text: 'Contact', to: 'contact' },
        ],
    },

    header: {
        text: ['Salut !', "Je suis Ali Chaabane.", 'Je suis '],
        typical: [
            'Développeur Full Stack 💻',
            2000,
            'Développeur Web & Mobile 📱',
            2000,
        ],
        btnText: 'Découvrir plus',
    },

    stack: {
        title: 'Technologies utilisées',
         tech: [
            { img: process.env.PUBLIC_URL + '/assets/flutter.png', alt: 'Flutter' },
            { img: process.env.PUBLIC_URL + '/assets/ionic.png', alt: 'Ionic' },
            { img: process.env.PUBLIC_URL + '/assets/angular.png', alt: 'Angular' },
            { img: process.env.PUBLIC_URL + '/assets/spring.png', alt: 'Spring Boot' },
            { img: process.env.PUBLIC_URL + '/assets/vue.png', alt: 'Vue.js' },
            { img: process.env.PUBLIC_URL + '/assets/nuxt.png', alt: 'Nuxt.js' },
            { img: process.env.PUBLIC_URL + '/assets/node.png', alt: 'Node.js' },
            { img: process.env.PUBLIC_URL + '/assets/express.png', alt: 'Express.js' },
        ],
        desc: `
Je suis spécialisé dans le développement web et mobile multiplateforme.

Pour les applications mobiles, j’utilise principalement Flutter et Ionic
afin de créer des applications performantes pour Android, iOS
ainsi que des Progressive Web Apps (PWA).

Côté web et backend, je travaille principalement avec Angular et Node.js (Express),
ainsi qu’avec Java Spring Boot pour développer des services backend
scalables et maintenables.

Je mets l’accent sur une architecture propre, la performance
et des solutions prêtes pour la production,
tout en améliorant continuellement mes compétences.
        `,
    },

    languages: {
        title: 'Langues',
        list: [
            { name: 'Arabe', level: 'Langue maternelle', percent: 100 },
            { name: 'Anglais', level: 'Avancé', percent: 90 },
            { name: 'Français', level: 'Avancé', percent: 80 },
            { name: 'Italien', level: 'Utilisation pratique au travail', percent: 30 },
            { name: 'Turc', level: 'Intermédiaire', percent: 40 },
        ],
    },

    project: {
        visible: false,
        title: 'Projets',
        img: process.env.PUBLIC_URL + '/assets/project-mobile.png',
        imgPlaceholder: 'data:image/png;base64,...',
        projectName: 'Meetup',
        desc: 'Premiers pas avec l’application Meetup (mon premier projet React)',
        website: 'https://meetups-project-86e41.web.app/',
    },

    contact: {
        title: 'Me contacter',
        desc: `
Développeur Full Stack avec plus de 5 ans d’expérience
dans le développement d’applications web et mobiles multiplateformes.

Solide expérience pratique avec Flutter, Ionic, Angular, Node.js
et Java Spring Boot, ayant travaillé sur des applications
entreprise et e-commerce en production pour des clients internationaux.

Orienté vers des solutions scalables, propres et maintenables,
je m’intègre rapidement aux environnements Agile
et je collabore efficacement au sein des équipes.
        `,
    socials: [
      {
        alt: 'whatsapp',
        img: process.env.PUBLIC_URL + '/assets/whatsapp.png',
        link: 'https://api.whatsapp.com/send/?phone=905421959236',
      },
      {
        alt: 'email',
        img: process.env.PUBLIC_URL + '/assets/gmail.png',
        link: 'mailto:alichaabane.work@gmail.com',
      },
      {
        alt: 'linkedin',
        img: process.env.PUBLIC_URL + '/assets/link.png',
        link: 'https://www.linkedin.com/in/ali-chaabane/',
      },
      {
        alt: 'github',
        img: process.env.PUBLIC_URL + '/assets/github.png',
        link: 'https://github.com/alichaabane',
      },
    ],
    img: process.env.PUBLIC_URL + '/assets/my-image.jpg',
    },
};

export default content;
